module.exports = __webpack_public_path__ + "static/media/gymet_6.ac9e0f7a.png";